import React, { useEffect, useState } from 'react';

export const MappingRow = ({ row, updateRow, roleOptions, pagesOptions }) => {
  const [key, setKey] = useState(row.key || '');
  const [value, setValue] = useState(row.value || '');

  useEffect(() => {
    setKey(row.key || '');
    setValue(row.value || '');
  }, [row]);

  const handleKeyChange = (e) => {
    const newKey = e.target.value;
    setKey(newKey);
    updateRow({ ...row, key: newKey });
  };

  const handleValueChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    updateRow({ ...row, value: newValue });
  };

  return (
    <tr className="col-md-12 col-lg-12">
      <td className="col-md-6 col-lg-6">
        <div className="row">
          <div className="col-md-12 col-lg-12">
            <select
              name="key"
              onChange={handleKeyChange}
              className="form-control form-control-sm custom-select-sm"
              value={key}
            >
              <option value="">- Select One -</option>
              {roleOptions.map((e) => (
                <option key={e.value} value={e.value}>
                  {e.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </td>
      <td className="col-md-6 col-lg-6">
        <select
          name="value"
          onChange={handleValueChange}
          className="form-control form-control-sm custom-select-sm"
          value={value}
        >
          <option value="">- Select One -</option>
          {pagesOptions.map((e) => (
            <option key={e.value} value={e.value}>
              {e.label}
            </option>
          ))}
        </select>
      </td>
    </tr>
  );
};
